/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_LocationInputs */

const en_resume_location = /** @type {(inputs: Resume_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const ar_resume_location = /** @type {(inputs: Resume_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الموقع`)
};

const bn_resume_location = /** @type {(inputs: Resume_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ঠিকানা`)
};

const de_resume_location = /** @type {(inputs: Resume_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort`)
};

const es_resume_location = /** @type {(inputs: Resume_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicación`)
};

const fr_resume_location = /** @type {(inputs: Resume_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emplacement`)
};

const pt_resume_location = /** @type {(inputs: Resume_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Localização`)
};

const zh_resume_location = /** @type {(inputs: Resume_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置`)
};

const tr_resume_location = /** @type {(inputs: Resume_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konum`)
};

const ru_resume_location = /** @type {(inputs: Resume_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Местоположение`)
};

const pl_resume_location = /** @type {(inputs: Resume_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokalizacja`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {Resume_LocationInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_location = /** @type {((inputs?: Resume_LocationInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_LocationInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_location(inputs)
	if (locale === "bn") return bn_resume_location(inputs)
	if (locale === "de") return de_resume_location(inputs)
	if (locale === "es") return es_resume_location(inputs)
	if (locale === "fr") return fr_resume_location(inputs)
	if (locale === "pt") return pt_resume_location(inputs)
	if (locale === "zh") return zh_resume_location(inputs)
	if (locale === "tr") return tr_resume_location(inputs)
	if (locale === "ru") return ru_resume_location(inputs)
	if (locale === "pl") return pl_resume_location(inputs)
	return en_resume_location(inputs)
});